export const isValidEmailInput = (emailInput?: string | null) => {
  if (emailInput == null) {
    return true;
  }
  const regExp = new RegExp(
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
  );
  const emailSplitted = emailInput.split(/,|;/);
  return emailSplitted.every((email) => !email || regExp.test(email));
};

/**
 * Mirrors the colugo rule for `purchasing_order_email`: comma or semicolon
 * separated, every address valid. Checked here as well so the operator sees the
 * problem while typing rather than as a failed save. The number of recipients
 * is not capped — the backend does not cap it either.
 */
export const isValidPurchasingOrderEmailInput = (input?: string | null) => {
  if (input == null || input.trim() === '') {
    return true;
  }
  const addresses = input
    .split(/,|;/)
    .map((address) => address.trim())
    .filter((address) => address.length > 0);
  return isValidEmailInput(addresses.join(';'));
};
